import React from "react";
import { Box, Grid, useTheme } from "@mui/material";
import Header from "../../components/VersatileComponents/Header";
import { Helmet } from "react-helmet-async";
import BillTypeTable from "../../components/Bills/BillTypeTable";
import BillTable from "../../components/Bills/BillTable";

const Bills = () => {
  const theme = useTheme();

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Bills</title>
        <meta name="description" content="Bills management page" />
      </Helmet>
      <Box
        m="1.5rem 2.5rem"
        sx={{
          backgroundcolor: theme.palette.background.default,
          height: "100%",
          position: "relative",
        }}
      >
        <Header title="Bills" subtitle="Bills management section" />

        {/* Bill Types Section */}
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <BillTypeTable />
          </Grid>
        </Grid>

        {/* Bills Section */}
        <Box mt={4}>
          <BillTable />
        </Box>
      </Box>
    </>
  );
};

export default Bills;
